var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 22.8961L15.4122 21.6521C15.6468 21.5934 15.8602 21.4721 16.0322 21.3014L27.2188 10.1147C28.2602 9.07341 28.2602 7.38541 27.2188 6.34407L26.9895 6.11474C25.9482 5.07341 24.2602 5.07341 23.2188 6.11474L12.0322 17.3014C11.8615 17.4721 11.7402 17.6867 11.6815 17.9214L10.4375 22.8961",
    stroke: "#F08181",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1064 8.22656L25.1064 12.2266",
    stroke: "#F08181",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3944 21.6559C15.4131 21.5145 15.4371 21.3745 15.4371 21.2279C15.4371 19.3865 13.9451 17.8945 12.1038 17.8945C11.9571 17.8945 11.8171 17.9199 11.6758 17.9372",
    stroke: "#F08181",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17.4226V25.2959C28 26.7893 26.7987 27.9999 25.316 27.9999H6.684C5.20133 27.9999 4 26.7893 4 25.2959V8.03725C4 6.54392 5.20133 5.33325 6.684 5.33325H16",
    stroke: "#F08181",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.20bc208cd22000ec3abf9c5e4cea4134.svg";
export { ForwardRef as ReactComponent };